
import { SMAdditionalInfo } from "@/store";
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "Banner",

  setup() {
    function onValidateCandidate() {
      SMAdditionalInfo.inviteCandidate();
    }

    return {
      onValidateCandidate,
    };
  },
});
